import { render } from "./calander-widget.vue?vue&type=template&id=1c70d77f&scoped=true"
import script from "./calander-widget.vue?vue&type=script&lang=js"
export * from "./calander-widget.vue?vue&type=script&lang=js"

import "./calander-widget.vue?vue&type=style&index=0&id=1c70d77f&lang=scss&scoped=true"

import exportComponent from "D:\\Cater-Frontend\\cater\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c70d77f"]])

export default __exports__